import React from "react";
import logo from "../assets/Navbar (4).png";

function Navbar() {
  return (
    <header className="navbar">
      <img
        src={logo}
        alt="AstroCure Logo"
        style={{
          width: "100%",
          height: "80px",
          objectFit: "cover",
          display: "block",
          marginTop: "20px"
        }}
      />
    </header>
  );
}

export default Navbar;
